import React, { useState } from 'react';
import { Card, Space, Typography, Progress, Skeleton, Button, Tooltip, Segmented, Divider } from 'antd';
import { RobotOutlined, ThunderboltOutlined, BuildOutlined, TeamOutlined, DownloadOutlined, AppstoreOutlined, ProfileOutlined } from '@ant-design/icons';

const { Text } = Typography;

const AutomationRadar = ({ data, stats, efficiencyData, loading, onExport }) => {
  const [view, setView] = useState('Geral');
  const values = data?.datasets?.[0]?.data || [0, 0];
  const total = values.reduce((a, b) => a + b, 0);
  const labels = ['Feito pelo PIM', 'Intervenção Humana'];
  const colors = ['#071d9bff', '#94a3b8']; 
  const icons = [<BuildOutlined style={{ fontSize: 16 }} />, <TeamOutlined style={{ fontSize: 16 }} />];

  const getPercentage = (value) => total > 0 ? Math.round((value / total) * 100) : 0;

  const currentEfficiency = view === 'Regime' ? efficiencyData?.regime : 
                           view === 'Segmento' ? efficiencyData?.segmento : null;

  return (
    <Card
      title={
        <Space size={12}>
          <div style={{ background: '#f8fafc', padding: 8, borderRadius: 12, display: 'flex' }}>
            <RobotOutlined style={{ color: '#071d9bff', fontSize: 20 }} />
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 16, lineHeight: 1.2 }}>Radar de Automação PIM</div>
            <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 400 }}>Desempenho e Eficiência</div>
          </div>
        </Space>
      }
      extra={
        <Space>
          <Segmented
            size="small"
            options={[
              { label: 'Geral', value: 'Geral', icon: <ThunderboltOutlined style={{ fontSize: 14 }} /> },
              { label: 'Regime', value: 'Regime', icon: <AppstoreOutlined style={{ fontSize: 14 }} /> },
              { label: 'Segmento', value: 'Segmento', icon: <ProfileOutlined style={{ fontSize: 14 }} /> }
            ]}
            value={view}
            onChange={setView}
            style={{ background: '#f1f5f9', borderRadius: 8 }}
          />
          {onExport && (
            <Tooltip title="Exportar dados do radar">
              <Button 
                type="text" 
                icon={<DownloadOutlined style={{ fontSize: 16 }} />} 
                onClick={onExport}
                style={{ color: '#64748b' }}
              />
            </Tooltip>
          )}
        </Space>
      }
      bordered={false}
      style={{ borderRadius: 24, boxShadow: '0 10px 40px rgba(0,0,0,0.04)' }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        <div style={{ padding: '10px 0' }}>
          {view === 'Geral' ? (
            <>
              <div style={{ marginBottom: 30, textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 800, letterSpacing: 1 }}>EFICIÊNCIA GLOBAL DO PIM</div>
                <div style={{ fontSize: 44, fontWeight: 900, color: '#071d9bff' }}>{stats?.aiPercentage || 0}%</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
                {labels.map((label, index) => {
                  const val = values[index];
                  const pct = getPercentage(val);
                  return (
                    <div key={index}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
                        <Space size={10}>
                          <div style={{ color: colors[index], display: 'flex' }}>{icons[index]}</div>
                          <Text strong style={{ fontSize: 13, color: '#334155' }}>{label}</Text>
                        </Space>
                        <Space size={12}>
                          <Text style={{ fontSize: 13, color: '#64748b' }}>{val} Empresas</Text>
                          <Text strong style={{ fontSize: 13, color: '#0f172a' }}>{pct}%</Text>
                        </Space>
                      </div>
                      <Progress
                        percent={pct}
                        showInfo={false}
                        strokeColor={colors[index]}
                        strokeWidth={12}
                        style={{ margin: 0 }}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div style={{ marginBottom: 10, textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 800, letterSpacing: 1 }}>EFICIÊNCIA POR {view.toUpperCase()}</div>
              </div>
              {currentEfficiency?.map((item, index) => (
                <div key={index}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <Text strong style={{ fontSize: 12 }}>{item.name}</Text>
                    <Text style={{ fontSize: 12, color: '#64748b' }}>{item.pim}/{item.total} • <b>{item.percent}%</b></Text>
                  </div>
                  <Progress 
                    percent={item.percent} 
                    size="small" 
                    strokeColor={item.percent > 50 ? '#071d9bff' : '#3b82f6'} 
                    trailColor="#f1f5f9"
                  />
                </div>
              ))}
            </div>
          )}

          <div style={{
            marginTop: 30,
            padding: '16px',
            background: '#f8fafc',
            borderRadius: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Space>
              <Text style={{ fontSize: 12, color: '#64748b' }}>Referência: Lançamentos da empresa {'>'} 80% pelo PIM</Text>
            </Space>
          </div>
        </div>
      )}
    </Card>
  );
};

export default AutomationRadar;

